import { render, staticRenderFns } from "./bookmarksTabs.vue?vue&type=template&id=43a2ca97&scoped=true&"
import script from "./bookmarksTabs.vue?vue&type=script&lang=js&"
export * from "./bookmarksTabs.vue?vue&type=script&lang=js&"
import style0 from "./bookmarksTabs.vue?vue&type=style&index=0&id=43a2ca97&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a2ca97",
  null
  
)

export default component.exports